import MaterialPropertyAssigner from "../../../output/assets/materials/material-property-assigner.js";

class ThreeMaterialTransparencyAssigner extends MaterialPropertyAssigner {
    constructor() {
        super();
    }

    setProperty(material, property, newValue) {
        switch (property) {
            case "transparent":
            case "opacity":
                material[property] = newValue;
                break;

            case "premultipliedAlpha": {
                const oldValue = material.premultipliedAlpha;
                material.premultipliedAlpha = newValue;

                if (oldValue !== newValue) {
                    material.needsUpdate = true;
                }

                break;
            }

            default:
                throw new Error("Invalid material transparency property: "+String(property));
        }
    }
}

export default ThreeMaterialTransparencyAssigner;
